// @flow
import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import flatMap from 'lodash/flatMap';
import map from 'lodash/map';
import { EntityRoutes } from 'routes/constants';
import API from 'services/API';
import { Endpoints } from 'UI/constants/endpoints';

export const useNewCandidateFromResume = () => {
  const [uiState, setUiState] = useState({
    hasLoaded: false,
    isLoading: false,
    isSaving: false,
    isSuccess: false,
    shouldReset: false,
    showSuccessAlert: false
  });

  const [attachments, setAttachments] = useState([]);

  const history = useHistory();

  const canStart = attachments.filter(attachment => !attachment.isLoading).length > 0;

  const handleFilesChanged = useCallback(allCategories => {
    const attachmentsChanged = flatMap(map(allCategories, 'files'));
    setAttachments(attachmentsChanged);
  }, []);

  const handleClickSecondaryButton = () => {
    history.push(EntityRoutes.CandidateCreate);
  };

  const handleReset = useCallback(
    () => setUiState(prevState => ({ ...prevState, shouldReset: false })),
    []
  );
  const resetFlow = () => {
    setUiState(prevState => ({
      ...prevState,
      isSuccess: false,
      shouldReset: true,
      showSuccessAlert: true
    }));
    setAttachments([]);
  };

  const hideSuccessAlert = () => {
    setUiState(prevState => ({ ...prevState, showSuccessAlert: false }));
  };

  const handleSubmit = async () => {
    try {
      const file = canStart && attachments[0];
      if (!file) return;

      setUiState(prevState => ({ ...prevState, isSaving: true }));

      const response = await API.post(Endpoints.CandidatesResumeParser, {
        fileId: file.id
      });

      if (response.data && response.status !== HTTPStatusCodes.Accepted) {
        setUiState(prevState => ({
          ...prevState,
          isSaving: false,
          isSuccess: false
        }));

        return;
      }

      setUiState(prevState => ({
        ...prevState,
        isSuccess: true
      }));
    } catch (err) {
      setUiState(prevState => ({
        ...prevState,
        isSuccess: false
      }));
    } finally {
      setUiState(prevState => ({
        ...prevState,
        isSaving: false
      }));
    }
  };

  return {
    attachments,
    handleClickSecondaryButton,
    handleFilesChanged,
    canStart,
    handleReset,
    handleSubmit,
    hideSuccessAlert,
    resetFlow,
    uiState
  };
};
